import script from "./BlockInputNationalId.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockInputNationalId.vue?vue&type=script&setup=true&lang=js"

import "./BlockInputNationalId.vue?vue&type=style&index=0&id=5f7e375c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f7e375c"]])

export default __exports__